// eslint-disable-next-line import/no-cycle
import { client } from './index';

const keycabinetTopics = {
  KEYCABINET_LIST: '/vanma/key-cabinet/+/recovery',
};

const handler = {
  onRecovery: null,
};

export const keycabinetMiddleware = (topic, payload) => {
  // 钥匙柜发现事件，定于时使用+通配符，但返回时返回的是真实id
  if (topic.endsWith('recovery')) {
    handler.onRecovery(payload);
  } else if (handler[topic]) {
    handler[topic](payload);
    handler[topic] = null;
    delete handler[topic];
    client.unsubscribe(topic);
  }
};

// 获取钥匙盒列表，理论上此监听不需要前台进行处理，后台监听然后实时更新数据库即可
export const subscribeKeycabinet = callback => {
  client.subscribe(keycabinetTopics.KEYCABINET_LIST, err => {
    console.log('mqtt add', 'KEYCABINET_LIST', err);
    if (!err) handler.onRecovery = callback;
    else console.warn(err);
  });
};

export const unsubscribeKeycabinet = () => {
  client.unsubscribe(keycabinetTopics.KEYCABINET_LIST, err => {
    console.log('mqtt remove', 'KEYCABINET_LIST', err);
    if (!err) handler.onRecovery = null;
    else console.warn(err);
  });
};
